import {
  createActionTypes,
  createAsyncActionTypes,
} from '../../util/createLifeomicActionTypes';

const actions = createActionTypes([
  'PAYMENT_METHOD_UPDATE_START',
  'PAYMENT_METHOD_UPDATE_PAGE_LOADED',
  'PAYMENT_METHOD_UPDATE_SUCCESS',
  'PAYMENT_METHOD_UPDATE_FAIL',
  'PAYMENT_METHOD_UPDATE_RESET',
]);

const asyncActions = createAsyncActionTypes([
  'CREATE_PAYMENT_METHOD_UPDATE_PAGE',
  'CREATE_PAYMENT_METHOD_UPDATE_PAGE_START',
  'CREATE_PAYMENT_METHOD_UPDATE_PAGE_SUCCESS',
  'CREATE_PAYMENT_METHOD_UPDATE_PAGE_ERROR',
]);

export default {
  ...actions,
  ...asyncActions,
};
